import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import AuthInitComponent from './components/AuthInitComponent';
var TransmitWebSDKEnterpriseAuth = function (props) {
    var clearSession = function () {
        sessionStorage.removeItem('currentSession');
    };
    clearSession();
    var customUI = props.customUI, params = props.params, config = props.config, handleAuthResponse = props.handleAuthResponse;
    var showAuth = true;
    var handleAuth = function (response) {
        showAuth = false;
        var resultResponse;
        if (response.getInternalData !== undefined) {
            resultResponse = response.getInternalData().json_data;
        }
        else {
            resultResponse = response;
        }
        var _a = resultResponse.status, responseCode = _a.response_code, responseDesc = _a.response_desc, transId = _a.trans_id, token = resultResponse.token, iovationStatus = resultResponse.iovation_status, decision = resultResponse.decision, applicantId = resultResponse.applicant_id, applicationId = resultResponse.application_id, mfaStatus = resultResponse.mfa_status;
        var finalResponse = {
            status: {
                responseCode: responseCode,
                responseDesc: responseDesc,
                transId: transId
            },
            token: token,
            iovationStatus: iovationStatus,
            decision: decision,
            applicantId: applicantId,
            applicationId: applicationId,
            mfaStatus: mfaStatus
        };
        handleAuthResponse(finalResponse);
    };
    useEffect(function () {
        var abortController = new AbortController();
        return function cancel() {
            abortController.abort();
        };
    }, []);
    return (_jsx("div", { children: showAuth ? (_jsx(AuthInitComponent, { config: config, params: params, handleAuthResponse: handleAuth, customUI: customUI })) : null }));
};
export default TransmitWebSDKEnterpriseAuth;
